export class TforensicDateString {
    time_24Hour: string;  
    time_12Hour: string;
    shortDate: string;
    mediumDate: string;
  }
  